// import React, { useEffect, useRef } from 'react'
// import styles from './style.module.scss'

// const ImageDisplay = ({ image, onClose, onNext, onPrevious }) => {

//     const galleryContainerRef = useRef(null);
//     let touchStartX;


//     useEffect(() => {
//         const handleKeyPress = (e) => {
//             if (e.key === 'ArrowLeft') {
//                 onPrevious();
//             } else if (e.key === 'ArrowRight') {
//                 onNext();
//             }
//         };

//         const handleTouchStart = (e) => {
//             touchStartX = e.touches[0].clientX;
//         };
//         const handleTouchEnd = (e) => {
//             const touchEndX = e.changedTouches[0].clientX;
//             if (touchEndX < touchStartX) {
//                 onNext();
//             } else if (touchEndX > touchStartX) {
//                 onPrevious();
//             }
//         };

//         window.addEventListener('keydown', handleKeyPress);
//         galleryContainerRef.current.addEventListener('touchstart', handleTouchStart);
//         galleryContainerRef.current.addEventListener('touchend', handleTouchEnd);

//         return () => {
//             if (galleryContainerRef.current) {
//                 window.removeEventListener('keydown', handleKeyPress);
//                 galleryContainerRef.current.removeEventListener('touchstart', handleTouchStart);
//                 galleryContainerRef.current.removeEventListener('touchend', handleTouchEnd);
//             }
//         };
//     }, [onNext, onPrevious]);

//     return (
//         <div className={styles.imageOverlay} onClick={onClose} ref={galleryContainerRef}>
//             <img src={image} alt="Selected Image" onClick={e => e.stopPropagation()} />
//             <br />
//             {/* <p>name: {image}</p> */}
//         </div>
//     )
// }

// export default ImageDisplay


import React, { useEffect, useRef } from 'react';
import styles from './style.module.scss';

const ImageDisplay = ({ image, onClose, onNext, onPrevious }) => {
  const galleryContainerRef = useRef(null);
  const touchStartX = useRef(null);

  const handleClose = () => {
      galleryContainerRef.current.querySelector('img').style.scale = "0.5";
      galleryContainerRef.current.querySelector('img').style.opacity = "0";
      galleryContainerRef.current.style.backgroundColor = "transparent";
      setTimeout(() => {
        onClose();
      }, 300);
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'ArrowLeft') {
        onPrevious();
      } else if (e.key === 'ArrowRight') {
        onNext();
      }
    };

    const handleTouchStart = (e) => {
      touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      if (touchStartX.current !== null) {
        if (touchEndX < touchStartX.current) {
          onNext();
        } else if (touchEndX > touchStartX.current) {
          onPrevious();
        }
      }
    };

    const galleryContainer = galleryContainerRef.current;

    // Add event listeners
    window.addEventListener('keydown', handleKeyPress);
    if (galleryContainer) {
      galleryContainer.addEventListener('touchstart', handleTouchStart);
      galleryContainer.addEventListener('touchend', handleTouchEnd);
    }

    return () => {
      // Cleanup event listeners
      window.removeEventListener('keydown', handleKeyPress);
      if (galleryContainer) {
        galleryContainer.removeEventListener('touchstart', handleTouchStart);
        galleryContainer.removeEventListener('touchend', handleTouchEnd);
      }
    };
  }, [onNext, onPrevious]); // Dependencies ensure listeners update correctly

  return (
    <div
      className={styles.imageOverlay}
      onClick={handleClose}
      ref={galleryContainerRef}
    >
      <img
        src={image}
        alt="Selected Image"
        onClick={(e) => e.stopPropagation()} // Prevent overlay close on image click
      />
    </div>
  );
};

export default ImageDisplay;
